module.exports = __webpack_public_path__ + "img/activity2.f41911dd.svg";